// extracted by mini-css-extract-plugin
module.exports = {"easter-wrapper":"ItIsEaster_easter-wrapper__3k2xA","fadeIn":"ItIsEaster_fadeIn__3jb--","fairy":"ItIsEaster_fairy__TfIKd","flying":"ItIsEaster_flying__3w2CN"};